import dayjs from 'dayjs';

export const getDisablingDates = ({
  minDate,
  maxDate,
}: {
  minDate?: Date;
  maxDate?: Date;
}) => {
  const now = dayjs();

  return {
    shouldDisableDate: (date: dayjs.Dayjs) => {
      if (date.isAfter(now, 'day')) return true;
      if (maxDate && date.isAfter(dayjs(maxDate), 'day')) return true;
      if (minDate && date.isBefore(dayjs(minDate), 'day')) return true;
      return false;
    },

    shouldDisableMonth: (month: dayjs.Dayjs) => {
      const start = month.startOf('month');
      const end = month.endOf('month');

      if (start.isAfter(now, 'day')) return true;

      if (maxDate && end.isBefore(dayjs(maxDate), 'day') === false) {
        if (start.isAfter(dayjs(maxDate), 'day')) return true;
      }

      if (minDate && end.isBefore(dayjs(minDate), 'day')) return true;

      return false;
    },

    shouldDisableYear: (year: dayjs.Dayjs) => {
      const start = year.startOf('year');
      const end = year.endOf('year');

      if (start.isAfter(now, 'day')) return true;

      if (maxDate && end.isBefore(dayjs(maxDate), 'day') === false) {
        if (start.isAfter(dayjs(maxDate), 'day')) return true;
      }

      if (minDate && end.isBefore(dayjs(minDate), 'day')) return true;

      return false;
    },
  };
};
